export default __webpack_public_path__ + "static/media/ranes10.3668b762.jpg";